import { render, staticRenderFns } from "./NewWitnessTime.vue?vue&type=template&id=6847dcb8&"
import script from "./NewWitnessTime.vue?vue&type=script&lang=js&"
export * from "./NewWitnessTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports